<div class="global-overlay-page">
  <div style="display: flex; justify-content: center; padding: 20px">
    <div style="width: 100%">
      <div style="display: flex; margin-top: 20px">
        <input
          type="text"
          (keyup)="filter($event)"
          placeholder="Filter questions"
        />

        @if (!scanning) {
          <div class="toolbar" style="margin-left: 20px">
            <a (click)="rescan()">Rescan trainings</a>
          </div>
        }
        <div style="padding-top: 3px; margin-left: 20px">{{ message }}</div>
      </div>

      <mat-table #table [dataSource]="dataSource">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef>ID</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.id }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="likert">
          <mat-header-cell *matHeaderCellDef>Likert</mat-header-cell>
          <mat-cell *matCellDef="let element"
            ><input type="checkbox" disabled [checked]="element.likert"
          /></mat-cell>
        </ng-container>

        <ng-container matColumnDef="question">
          <mat-header-cell *matHeaderCellDef>Question</mat-header-cell>
          <mat-cell *matCellDef="let element"
            ><span>{{ element.question }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="stmt">
          <mat-header-cell *matHeaderCellDef>Statement</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.stmt }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="template_key">
          <mat-header-cell *matHeaderCellDef>Key</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span
              class="template-key-label"
              (click)="openTemplateKeyModal(element)"
              >{{ element.label || "Set key" }}</span
            >
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          [ngClass]="{ 'active-row': row.active }"
          *matRowDef="let row; columns: displayedColumns"
        ></mat-row>
      </mat-table>

      <mat-paginator
        [pageSize]="10"
        showFirstLastButtons
        hidePageSize="true"
      ></mat-paginator>
    </div>
  </div>

  <div>
    <p>
      When a new training is created or updated, we need to rescan the trainings
      for any new likerts (score from X to Y).
    </p>
    <p>A new likert will receive a
      unique identifier as its key.
    </p>
    <p>
      Each likert must have a key. Multiple likerts can share the same key, if
      they are saying essentially the same thing.
    </p>
    <p>
      The key will be used to group responses across multiple questions in the
      annual/executive report, as well as in the feedback report.
    </p>
  </div>
</div>
